// Utilities
import {parseJsonAttribute} from '../utilities/utilities';

// Components
import Modal from './modal';

const settings = {
    hideModalUntilIFrameLoads: true,

    dataAttributes: {
        parameters: 'data-video-modal',
    },

    classNames: {
        modal: 'modal--video',
        loaded: 'modal--loaded',
    },

    selectors: {
        openModalButtons: '*[data-video-modal]',
    },

    template: `<iframe name="video-modal--%% NAME %%" frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen></iframe>`,

    vimeoUrlRegex: /player\.vimeo\.com\/video\/(?<id>\d+)/i,
};

export default class VideoModal {
    constructor(openModalButton) {
        // Parse our parameters provided via JSON in an HTML attribute
        const parameters = parseJsonAttribute(
            openModalButton,
            settings.dataAttributes.parameters,
        );

        // Make sure the required parameters were provided
        if (
            !parameters.src ||
            !parameters.trackingName
        ) {
            return;
        }

        // Configure the "name" attribute of the iframe - this is used
        // for analytics tracking to detect which video is presented
        const template = settings.template
            .replace('%% NAME %%', parameters.trackingName);

        // Setup our click event
        const clickCallback = (event) => {
            event.preventDefault();

            Modal.show(
                template,
                settings.classNames.modal,
                Modal.presentationTypes.scaleUp,
                Modal.presentationTypes.scaleDown,
                true,
                false,
                {
                    preShow: function() {
                        const modal = this;

                        // Find the iframe within the modal
                        const iframe = modal.content.querySelector('iframe');
                        if (iframe) {
                            const showModal = () => {
                                modal.container
                                    .classList
                                    .add(settings.classNames.loaded);

                                // If we opened due to a keyboard event, set focus on the close button
                                if (event instanceof KeyboardEvent) {
                                    modal.closeButton.focus();
                                }
                            };

                            if (settings.hideModalUntilIFrameLoads) {
                                // Detect when the iframe has loaded
                                const loadCallback = () => {
                                    if (timeout) {
                                        clearTimeout(timeout);
                                        timeout = null;
                                    }

                                    // Add "loaded" class after a (very) slight delay -
                                    // we're trying to give the layout time to size to
                                    // the image before the modal becomes visible, as
                                    // otherwise it would briefly appear too small
                                    setTimeout(
                                        showModal,
                                        10,
                                    );
                                };

                                let timeout = setTimeout(
                                    () => {
                                        timeout = null;
                                        loadCallback();
                                    },
                                    500,
                                );

                                iframe.addEventListener('load', loadCallback);
                            } else {
                                // We're not waiting for the iframe to load
                                showModal();
                            }

                            // Set the iframe's "title" and "src" attributes, the latter
                            // of which will eventually trigger the "load" event
                            if (parameters.title) {
                                iframe.setAttribute('title', parameters.title);
                            }

                            iframe.src = parameters.src;
                        }
                    },

                    postClose: function() {
                        // If we opened due to a keyboard event, set focus on the button
                        // that caused the modal to open (ideally this would be triggered
                        // based on a keyboard event when the modal is closed)
                        if (event instanceof KeyboardEvent) {
                            openModalButton.focus();
                        }
                    },
                },
                event,
            );
        };

        openModalButton.addEventListener(
            'keydown',
            (event) => {
                if (event.key != 'Enter') {
                    return;
                }

                clickCallback(event);
            });

        openModalButton.addEventListener('click', clickCallback);
    }

    static init() {
        // Find elements with the expected class name
        const elements = document
            .querySelectorAll(settings.selectors.openModalButtons);

        for (let i=0; i<elements.length; i++) {
            new VideoModal(elements[i]);
        }
    }
}
